import { createApiFactory, createPlugin, createRoutableExtension, discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { EpDevPPluginIds } from '@solace-labs/backstage-plugin-ep-devp-common';
import { EpDevPConsumerProductsApiClient } from "../../ep-devp-consumer-products-common";
import { epDevPConsumerProductsApiRef } from './apis';
import { rootRouteRef } from './routes';

/** @public */
export const epDevPConsumerProductsPlugin = createPlugin({
  id: EpDevPPluginIds.EpDevPConsumerProductsPluginId,
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: epDevPConsumerProductsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new EpDevPConsumerProductsApiClient({
          discoveryApi: discoveryApi,
          fetchApi: fetchApi
        }),
    }),
  ]
});

/** @public */
export const EpDevPConsumerProductsPage = epDevPConsumerProductsPlugin.provide(
  createRoutableExtension({
    name: 'EpDevPConsumerProductsPage',
    component: () =>
      import('./components/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),

);